import React, { useMemo } from 'react';
import PlusCircleIcon from '../../Components/Icons/PlusCircleIcon';
import { BtnSecondaryWithIcon } from '../../Components/Buttons/BtnWithIcon/BtnSecondaryWithIcon';
import { useGetServiceAddons } from '../../APICalling/useApiQueries';
import { useLocation } from '../../Context/Location/LocationContext';
import styles from './Style.module.css';

export const ServiceAddons = ({
  serviceId,
  selectedAddonsCount = 0,
  onAddClick,
  children,
}) => {
  const { selectedOutletID } = useLocation();

  const addonParams = useMemo(() => ({
    service_id: serviceId,
    outlet_id: selectedOutletID,
    status: 1,
  }), [selectedOutletID, serviceId]);

  const { data: addonData } = useGetServiceAddons(addonParams);

  const addonGroups = addonData?.data?.data || [];
  const totalAvailableAddons = addonGroups.reduce((sum, group) => sum + (group?.addons?.length || 0), 0);

  return (
    <div className={`${styles.serviceAddons} ${styles.serviceCardContent}`}>
      <p className={styles.label}>Add-ons:</p>
      {children}
      {(totalAvailableAddons === 0 || selectedAddonsCount < totalAvailableAddons) && (
        <BtnSecondaryWithIcon
          label="Add"
          icon={<PlusCircleIcon size={16} />}
          variant="smallPill"
          handleClick={onAddClick}
          disabled={totalAvailableAddons === 0}
        />
      )}
    </div>
  );
};
